import { Grid as MuiGrid, GridProps, GridSize } from '@mui/material';
import { ReactNode } from 'react';

interface GridComponentProps extends Omit<GridProps, 'children'> {
  children?: ReactNode;
  size?: GridSize;
  container?: boolean;
  spacing?: number;
}

export function Grid({ children, ...otherProps }: GridComponentProps) {
  return <MuiGrid {...otherProps}>{children}</MuiGrid>;
}
